import React from "react";
import { SafeAreaProvider } from "react-native-safe-area-context";

export const BaseRodioTheme = ({ children }) => {
  return <SafeAreaProvider>{children}</SafeAreaProvider>;
};
